import { FLAGS } from '@iheartjane/feature-flags';
import { CompareProducts } from '@iheartjane/menu';
import type { ReactNode } from 'react';

import type { MobileFiltersModalProps } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';
import { MobileFiltersModal } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';

import styles from './mobileFilterRow.module.css';

interface MobileFilterRowProps extends MobileFiltersModalProps {
  actionSlot?: ReactNode;
  showCompare?: boolean;
}

export function MobileFilterRow({
  actionSlot,
  showCompare = false,
  ...props
}: MobileFilterRowProps) {
  const { featureFlags, theme } = useRootLoaderData();
  const useCustomComponents = featureFlags?.[FLAGS.c2CustomComponents] ?? false;
  const showActionSlot = useCustomComponents
    ? actionSlot && theme?.bloom?.search?.position === 'split'
    : actionSlot;
  return (
    <div className={styles['mobileFilterRow']}>
      <MobileFiltersModal {...props} />
      {showActionSlot && (
        <div className={styles['mobileActionSlot']}>{actionSlot}</div>
      )}
      {!useCustomComponents && showCompare && <CompareProducts.Button />}
    </div>
  );
}
